import React from 'react';
import styles from './TreeMenuLinkHttpMethod.scss';
import classnames from 'classnames';
import { Text } from '../../PageElements/Text';

export const TreeMenuLinkHttpMethod = ({ method, size = '' }) => {
  const className = classnames({
    [styles.method]: true,
    [styles[method && method.toLowerCase()]]: true,
    [styles[size]]: true,
  });
  return method ? (
    <Text size="small" weight="normal" secondary className={className}>
      {method}
    </Text>
  ) : null;
};
